























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storePpiIad } from "@/store/modules/PpiIadStore";
import { appModule } from "@/store/modules/app";
import PpiIadSvc from "@/services/PpiIadService";
import BundleItemTriState from "@/components/pemeriksaan/bundle-ppi/BundleItemTriState.vue";
import BundleObservasiList from "@/components/pemeriksaan/bundle-ppi/BundleObservasiList.vue";
import {
  labelObservasi,
  nowHm,
  todayIso,
  trimJam,
  trimTanggal
} from "@/utils/bundlePpiObservasi";

@Component({
  components: { BundleItemTriState, BundleObservasiList }
})
export default class PpiIadPage extends Vue {
  @Prop() register!: string | number;
  @Prop() rm!: string | number;
  @Prop({ default: false }) isActive!: boolean;

  get readOnly(): boolean {
    return false;
  }

  form: any = this.defaultForm();
  saving = false;
  deleteDialog = false;
  deleting = false;
  loaded = false;
  rowToDelete: any = null;
  /** Form baru tampil setelah "Tambah Observasi" atau saat satu baris dibuka. */
  showForm = false;

  /** null = item belum/tidak dinilai (tidak masuk denominator kepatuhan). */
  defaultForm() {
    return {
      tanggal_observasi: todayIso(),
      jam_observasi: nowHm(),
      ins_hand_hygiene: null,
      ins_apd_sesuai: null,
      ins_lokasi_optimal: null,
      ins_skin_prep_chg: null,
      mnt_hand_hygiene_cvc: null,
      mnt_review_kebutuhan: null,
      mnt_desinfeksi_hub: null,
      mnt_manipulasi_aseptik: null,
      mnt_ganti_balutan_72jam: null,
      mnt_ganti_set_infus: null,
    };
  }

  get ppiIad() { return storePpiIad.currentItem; }
  get list() { return storePpiIad.list; }
  get loading() { return storePpiIad.loading; }

  get judulForm(): string {
    return this.ppiIad && this.ppiIad.id
      ? "Ubah Observasi — " + labelObservasi(this.ppiIad)
      : "Observasi Baru";
  }

  /** Persen dihitung atas item yang DINILAI saja (kepatuhan_total dari server). */
  get kepatuhanPersen() {
    if (!this.ppiIad) return 0;
    const total = this.ppiIad.kepatuhan_total || 0;
    if (!total) return 0;
    const count = this.ppiIad.kepatuhan_count || 0;
    return Math.round((count / total) * 1000) / 10;
  }

  get kepatuhanColor() {
    const persen = this.kepatuhanPersen;
    if (persen >= 80) return "success";
    if (persen >= 50) return "warning";
    return "error";
  }

  @Watch("isActive", { immediate: true })
  onActiveChange(val: boolean) {
    if (val && !this.loaded) {
      this.fetchData();
      this.loaded = true;
    }
  }

  @Watch("ppiIad", { immediate: true })
  onDataChange() {
    if (this.ppiIad) this.populateForm();
    else this.form = this.defaultForm();
  }

  async fetchData() {
    await storePpiIad.getByRegister(this.register);
  }

  /** null dari server = "tidak dinilai" — harus ikut tersalin, jangan di-skip. */
  populateForm() {
    const d = this.ppiIad;
    Object.keys(this.form).forEach(key => {
      if (d[key] !== undefined) this.form[key] = d[key];
    });
    this.form.tanggal_observasi = trimTanggal(d.tanggal_observasi) || todayIso();
    this.form.jam_observasi = trimJam(d.jam_observasi);
  }

  labelObservasi(row: any): string { return labelObservasi(row); }

  tambahObservasi() {
    storePpiIad.select(null);
    this.showForm = true;
  }

  pilihObservasi(row: any) {
    storePpiIad.select(row);
    this.showForm = true;
  }

  tutupForm() {
    storePpiIad.select(null);
    this.showForm = false;
  }

  cetakObservasi(row: any) { PpiIadSvc.printPdf(row.id); }

  async save() {
    if (!this.form.tanggal_observasi) {
      appModule.NoticeDelay("Tanggal Observasi harus diisi");
      return;
    }
    this.saving = true;
    try {
      let resp;
      if (this.ppiIad?.id) {
        resp = await PpiIadSvc.update(this.ppiIad.id, { ...this.form, register_id: this.register, pasien_rm: this.rm });
      } else {
        resp = await PpiIadSvc.create({ ...this.form, register_id: this.register, pasien_rm: this.rm });
      }
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Berhasil menyimpan Bundle IAD");
        await storePpiIad.getByRegister(this.register);
        if (resp.data.data?.id) await storePpiIad.refresh(resp.data.data.id);
      }
    } catch (e) { /* handled by service */ }
    this.saving = false;
  }

  confirmDelete(row: any) {
    this.rowToDelete = row || this.ppiIad;
    this.deleteDialog = true;
  }

  async doDelete() {
    if (!this.rowToDelete?.id) {
      this.deleteDialog = false;
      return;
    }
    const terpilih = this.ppiIad && this.ppiIad.id === this.rowToDelete.id;
    this.deleting = true;
    try {
      const resp = await PpiIadSvc.destroy(this.rowToDelete.id);
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Berhasil menghapus observasi Bundle IAD");
        if (terpilih) this.tutupForm();
        await storePpiIad.getByRegister(this.register);
        this.deleteDialog = false;
        this.rowToDelete = null;
      }
    } catch (e) { /* handled by service */ }
    this.deleting = false;
  }

  beforeDestroy() { storePpiIad.reset(); }
}
